import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './BlogForm.css';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PhoneInput } from "react-international-phone";


const BlogForm = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        FName: '',
        LastName: '',
        Email: '',
        Company: '',
        Sales: '',
        Message: '',
        Number: '',
        Location: '',
    });

    const resetForm = () => {
        setFormData({
            FName: '',
            LastName: '',
            Email: '',
            Company: '',
            Sales: '',
            Message: '',
            Number: '',
            Location: '',
        });
        setSelectedImage(null); // Clear the image as well
    };

    const handlePhoneChange = (phone) => {
        setFormData((prev) => ({
            ...prev,
            Number: phone || "", // Ensure phone is a string
        }));
    };

    const validateForm = () => {
        const errors = [];

        // Required field validation
        if (!formData.FName.trim()) errors.push("First Name is required");
        if (!formData.Email.trim()) errors.push("Email is required");
        if (!formData.Message.trim()) errors.push("Message is required");
        if (!formData.Number.trim()) errors.push("Phone Number is required");
        if (!formData.Location.trim()) errors.push("Location is required");

        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (formData.Email && !emailRegex.test(formData.Email)) {
            errors.push("Please Enter A Valid Email Address");
        }

        // Phone number validation (basic check for minimum length)
        if (formData.Number && formData.Number.length < 10) {
            errors.push("Please Enter A Valid Phone Number");
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Validate form before submission
        const validationErrors = validateForm();
        if (validationErrors.length > 0) {
            // Show only the first error instead of multiple toasts
            toast.error(validationErrors[0]);
            return;
        }
    
        setLoading(true);
    
        try {
            const response = await fetch(
                "https://blueberry-travel.com/api/APIUser/SubmitEnquiryBBT",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );
    
            if (response.ok) {
                await response.json();
                toast.success("Enquiry Submitted. Our Team Will Contact You Shortly.");
                resetForm();
            } else {
                toast.error("Failed To Submit The Form. Please Try Again Later.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An Error Occurred While Submitting The Form.");
        } finally {
            setLoading(false);
        }
    };

    // Handle image upload


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result); // Set image preview
            };
            reader.readAsDataURL(file);

            toast.success("Image uploaded successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };



    return (
        <>
            <div className="form-section mt-5 ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className='marginTop'>
                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/form-image.png" alt="" className="position-relative w-100 h-100 ready-img"  loading="lazy" />
                            </div>
                            <div className="text position-absolute">
                                <h1 className="headings fs3 blog-form-h1">Ready to Share Your <span>Exciting Travel Story?</span></h1>
                            </div>
                        </div>
                        <div className="col-md-6 mt-xxl-5 mt-lg-3 ps-md-0">
                            <form className="mt-3 blog-form" onSubmit={handleSubmit}>
                                <div className="firstgrp d-flex gap-2">
                                    <input
                                        type="text"
                                        name="FName"
                                        placeholder="Name"
                                        className="form-control"
                                        value={formData.FName}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                FName: e.target.value,
                                            })
                                        }
                                        required
                                    />
                                    <input
                                        type="text"
                                        name="Email"
                                        placeholder="Email"
                                        className="form-control"
                                        value={formData.Email}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                Email: e.target.value,
                                            })
                                        }
                                        required
                                    />
                                </div>
                                <div className="firstgrp d-flex gap-2 mt-2">
                                    <PhoneInput
                                        country={"gb"}
                                        value={formData.Number}
                                        onChange={handlePhoneChange}
                                        inputClassName="form-control"
                                        containerClass="phone-input-container"
                                        className="blog-phone-container"
                                        inputProps={{
                                            name: "Number",
                                            required: true,
                                            placeholder: "Phone Number",
                                        }}
                                        enableSearch={true}
                                        preferredCountries={["gb", "us", "in"]}
                                        required
                                    />
                                    <input
                                        type="text"
                                        placeholder="Country"
                                        name="Location"
                                        className="form-control"
                                        list="country-list"
                                        value={formData.Location}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                Location: e.target.value
                                            })
                                        }
                                        
                                    />

                                </div>
                                <div className="textarea mt-2">
                                    <textarea
                                        name="Message"
                                        placeholder="Message"
                                        className="form-control pb-5"
                                        rows="3"
                                        value={formData.Message}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                Message: e.target.value,
                                            })
                                        }
                                        required
                                    ></textarea>
                                </div>
                                <div className="upload-image-container d-flex">
                                    <label className="btn d-flex gap-2 bg-transparent border-0 outline-0 upload-btn-blog ps-0">
                                        <LazyLoadImage
            effect="blur"

                                            src="https://blueberrywebsites.azureedge.net/bbt/icons/upload.svg"
                                            alt="Upload Icon"
                                            className="mt-md-2 mt-2"  loading="lazy" 
                                        />
                                        <p className=" fs5 mt-1 mt-md-2">Upload Image</p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            className="d-none"
                                        />
                                    </label>

                                    {/* Show Image Preview */}
                                    {selectedImage && (
                                        <div className="mt-3">
                                            <LazyLoadImage
            effect="blur"

                                                src={selectedImage}
                                                alt="Preview"
                                                className="img-fluid rounded mt-0"
                                                style={{ maxWidth: "123px", maxHeight: "140px", objectFit: "cover" }}  loading="lazy" 
                                            />
                                        </div>
                                    )}

                                    {/* <ToastContainer /> */}
                                </div>
                                <div className="carouselCaption blog-carousel-capton">
                                    <button className="btn fs4 fw-bold" type="submit" disabled={loading} >
                                        {loading ? 'Loading...' : 'SUBMIT'}
                                    </button>
                                </div>
                            </form>
                            <ToastContainer
                                position="top-center"
                                autoClose={3000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                style={{ zIndex: 9999999999 }}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BlogForm